import React from 'react';
import { Card, Image } from 'antd';
import { IPlanPhoto } from '../../../types/plans';
import { GridImages } from './GridImages';

interface PhotoGalleryProps {
  photos: IPlanPhoto[];
  count?: number;
}

export const PhotoGallery = ({ photos, count }: PhotoGalleryProps) => {
  if (!photos.length) return null;

  const ListItem = ({ item }: { item: IPlanPhoto }) => (
    <Card
      hoverable={true}
      styles={{ body: { display: 'none' } }}
      cover={
        <Image
          src={item.compressed?.url || item.original}
          style={{ aspectRatio: 1 / 1, objectFit: 'cover' }}
        />
      }
    />
  );

  return (
    <GridImages
      count={count}
      ListItem={ListItem}
      items={photos}
      title="Gallery"
      subTitle="These conceptual designs are offered for illustration purposes only. Your design will differ depending on your preferences, site conditions, and local regulations for your specific property."
    />
  );
};
